var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('HomeBanner1'),_c('Acheivements2'),_c('General3'),_c('AdmissionHome'),_c('Moreabout4'),_c('LatestEvents6'),_c('StudyatBU7'),_c('WhyChoose8'),_c('Features9'),_c('Accreditation10')],1)}
var staticRenderFns = []

export { render, staticRenderFns }